import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Linkable
} from "./chunk.HRTOWRLV.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-menu-item/jb-menu-item.scss?inline
var jb_menu_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
a {
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  position: relative;
  transform: translateZ(0);
}
a::before {
  background: #fff;
  bottom: 5px;
  content: "";
  height: 0%;
  position: absolute;
  right: 0;
  transition: height 0.4s ease-out 0s;
  width: 1px;
}
a::after {
  background-color: rgba(241, 242, 242, 0.3);
  bottom: 5px;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  transition: all 0.3s ease-in-out 0.4s;
  width: 10%;
}
a:hover::before {
  height: 50%;
  transition: height 0.6s ease-out 0.5s;
}
a:hover::after {
  transition: width 0.5s ease-out 0s;
  width: 100%;
}

/* stylelint-disable */
/* stylelint-enable */
p {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.secondary span, span {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --padding-bottom: var(--padding-bottom);
  --padding-top: var(--padding-top);
  display: block;
}

:host(.active) li a::before {
  bottom: 0;
  height: 0;
}
:host(.active) li a::after {
  background-color: rgba(241, 242, 242, 0.3);
  bottom: 0;
  left: 0;
  width: fit;
}
@media (min-width: 1281px) {
  :host(.active) li a::after {
    background-color: #fff;
    transition: width 0.3s ease-out 0s;
    width: 100%;
  }
  :host(.active) li a::before {
    height: 20px;
    transition: height 0.25s ease-out 0.35s;
  }
}
@media (hover: none) and (min-width: 600px) {
  :host(.active) li a::after {
    background-color: rgba(241, 242, 242, 0.3);
    bottom: 0;
    left: 0;
    width: 40px;
  }
  :host(.active) li a::before {
    bottom: 0;
    height: 0;
  }
}

li {
  list-style-type: none;
  opacity: 1;
  padding-top: var(--padding-top, 10px);
  position: relative;
  transition: opacity 0.2s ease-in, transform 0.35s ease-in-out;
  z-index: 100;
}
li:focus {
  box-shadow: none;
  outline: none;
}
li.secondary {
  --padding-top: 25px;
}
@media (min-width: 600px) {
  li.secondary {
    --padding-top: 24px;
  }
}
@media (min-width: 1281px) and (hover: hover) {
  li.secondary {
    --padding-top: 21px;
  }
}
li.hidden {
  opacity: 0;
}

li:hover,
li.active {
  cursor: pointer;
}
li:hover a::before,
li.active a::before {
  bottom: 0;
  height: 0;
}
li:hover a::after,
li.active a::after {
  background-color: rgba(241, 242, 242, 0.3);
  bottom: 0;
  left: 0;
  width: fit;
}
@media (min-width: 1281px) {
  li:hover a::after,
  li.active a::after {
    background-color: #fff;
    transition: width 0.3s ease-out 0s;
    width: 100%;
  }
  li:hover a::before,
  li.active a::before {
    height: 20px;
    transition: height 0.25s ease-out 0.35s;
  }
}
@media (hover: none) and (min-width: 600px) {
  li:hover a::after,
  li.active a::after {
    background-color: rgba(241, 242, 242, 0.3);
    bottom: 0;
    left: 0;
    width: 40px;
  }
  li:hover a::before,
  li.active a::before {
    bottom: 0;
    height: 0;
  }
}

a {
  color: #fff;
  display: block;
  overflow: hidden;
  padding: 0 20px 7px 0;
  padding-bottom: var(--padding-bottom, 7px);
  position: relative;
  text-decoration: none;
  transition: none;
  width: 100%;
  z-index: 1;
}
@media (min-width: 600px) {
  a {
    padding-bottom: var(--padding-bottom, 10px);
  }
}
@media (min-width: 1281px) and (hover: hover) {
  a {
    transition: padding-left 0.3s ease-in-out 0s;
    width: fit-content;
  }
}
@media (hover: none) and (width >= 600px) {
  a {
    transition: none;
  }
}

a:hover::before {
  height: 0;
}

a:hover::after {
  width: 40px;
}

a::after {
  background-color: rgba(204, 208, 209, 0.2);
  bottom: 0;
  content: "";
  left: 0;
  transition: all 0.2s ease-in-out 0.35s;
  width: 40px;
}

a::before {
  bottom: 0;
  height: 0;
}

span {
  font-size: 26px;
  font-size: 1.625rem;
  line-height: 35px;
  line-height: 2.1875rem;
  letter-spacing: 0;
  letter-spacing: 0;
  color: #fff;
  position: relative;
  z-index: 1;
}
@media (min-width: 1281px) {
  span {
    line-height: 43px;
    line-height: 2.6875rem;
    letter-spacing: normal;
  }
}
@media (min-width: 1281px) and (hover: hover) {
  span {
    font-size: 33px;
    font-size: 2.0625rem;
  }
}

.secondary {
  opacity: 1;
  position: relative;
  transition: opacity 0.35s ease-in;
}
.secondary span {
  font-size: 21px;
  font-size: 1.3125rem;
  line-height: 30px;
  line-height: 1.875rem;
  color: #fff;
}
@media (min-width: 1281px) and (hover: hover) {
  .secondary span {
    font-size: 22px;
    font-size: 1.375rem;
  }
}
.secondary a {
  margin-right: auto;
  padding-bottom: 10px;
}
.secondary jb-arrow-forward-icon {
  display: none;
}

p {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  letter-spacing: 1px;
  letter-spacing: 0.0625rem;
  border-left: none;
  color: #fff;
  text-transform: uppercase;
}

jb-arrow-forward-icon {
  fill: #fff;
  height: 27px;
  padding-top: 11px;
  position: absolute;
  right: 8px;
}
jb-arrow-forward-icon.hidden {
  opacity: 0 !important;
  z-index: -1 !important;
}
@media (min-width: 1281px) and (hover: hover) {
  jb-arrow-forward-icon {
    display: none;
  }
}`;

// src/components/jb-menu-item/jb-menu-item.ts
var JbMenuItem = class extends Initiable(Linkable(r2)) {
  constructor() {
    super(...arguments);
    this.hidden = false;
    this.notTabbable = false;
    this.type = "primary";
  }
  render() {
    return ke`<li class="${this.type} ${this.hidden ? "hidden" : ""}">
      <a
        data-linkable
        .tabIndex=${this.notTabbable ? -1 : 0}
      >
        <span>${this.text}</span>
        ${this.submenu && ke`<jb-arrow-forward-icon></jb-arrow-forward-icon>`} ${this.tag && ke`<p>${this.tag}</p>`}
      </a>
    </li>`;
  }
};
JbMenuItem.styles = r(jb_menu_item_default);
JbMenuItem.shadowRootOptions = { ...r2.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbMenuItem.prototype, "hidden", 2);
__decorateClass([
  n({ type: Object })
], JbMenuItem.prototype, "link", 2);
__decorateClass([
  n({ type: Boolean })
], JbMenuItem.prototype, "notTabbable", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "submenu", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "tag", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "text", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "type", 2);
JbMenuItem = __decorateClass([
  customElement("jb-menu-item")
], JbMenuItem);

export {
  JbMenuItem
};
